import { Injectable } from '@angular/core';
import _ from 'lodash';
import { ApiService } from 'src/app/services/api.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class HashtagService {

  hashTagQuery = new Subject<any>();
  refreshHashtags = new Subject<any>();
  removeHashtagsGlobal = new Subject<any>();

  constructor(
    private apiService: ApiService,
    private dashboardService: DashboardService
  ) {}
  
  getHashTags(data:any) {
    let obj:any = Object.assign({}, data)
    obj['module_key'] = this.dashboardService.moduleKey;  
    return this.apiService.post('api/notes/get-hash-tags', data);
  }

  updateHashTags(data:any) {
    return this.apiService.post('api/notes/update-hash-tags', data);
  }
}
